import { Application } from "@hotwired/stimulus"

const application = Application.start()

import { Modal, Dropdown, Tabs, Toggle, Popover, Slideover, Alert } from "tailwindcss-stimulus-components"
application.register('alert', Alert)
application.register('modal', Modal)
application.register('dropdown', Dropdown)
application.register('tabs', Tabs)
application.register('toggle', Toggle)
application.register('popover', Popover)
application.register('slideover', Slideover)

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
